import React from "react";
import type { Deal } from "@/lib/types/database/deals";
import type { TabContentProps } from "@/components/shared/UniversalDetailPage/types/detailPage";
import { DealTasks } from "../DealTasks";

export function DealTasksDisplay({ item }: TabContentProps<Deal>) {
  return <DealTasks dealId={item.id} dealTitle={item.title} />;
}
